/* eslint-disable no-param-reassign */
import produce from 'immer';
var cellSetsCreating = produce(function (draft) {
  draft.creatingCellSets = true;
});
export default cellSetsCreating;